import { cn } from '@/lib/utils';

type Severity = 'ok' | 'warn' | 'crit' | 'info';

interface SevPillProps {
  level: Severity;
  label: string;
  /** When the pill sits on a dark surface (Wenge / Sustainable Green),
   *  the label switches to Spring Wood; build guide §3.17. */
  onDark?: boolean;
  className?: string;
}

/**
 * Severity pill with shape+colour glyph, neutral label text.
 * Label NEVER carries the severity hue (build guide §3.17).
 * MUST NOT be placed on a Mist (`bg-section`) background — OK and
 * WARN glyphs fail 3:1 contrast there.
 */
export function SevPill({ level, label, onDark, className }: SevPillProps) {
  const variantClass = onDark ? `sev--${level}-on-dark` : `sev--${level}`;
  return (
    <span className={cn('sev', variantClass, onDark && 'sev--on-dark', className)}>
      <span className="glyph" aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
}
